<template>
  <div id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title"> Assign Courses</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <div id="slideout-container">
      <v-stepper v-model="e1" class="no-transition" alt-labels non-linear>
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1"
            >Select Users</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2"
            >Select Courses</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="max-height-list scroll-y">
            <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
              <v-text-field
                v-model="userSearch"
                label="Filter Users By Name"
                type="text"
                @change="applyStaffUserSearch"
                class="filter-user"
                append-icon="fa-search"
              ></v-text-field>
              <v-expansion-panels accordion v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header
                    expand-icon="mdi-menu-down"
                    color="grey50"
                    class="assigned-user-heading assigned-user-heading2"
                    >Users</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                    <v-data-table
                      v-model="selectedStaffUser"
                      :headers="userHeaders"
                      :options.sync="userOptions"
                      :server-items-length="serverUser2ItemsLength"
                      v-show="!loading"
                      :items="staffUsers"
                      item-key="id"
                      show-select
                      :items-per-page="5"
                      class="enrol-user-list-tbl"
                    ></v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-stepper-content>
          <v-stepper-content step="2" class="max-height-list scroll-y">
            <div class="filterSection">
            <v-text-field
                v-model="courseSearch"
                label="Filter Course By Name"
                type="text"
                @change="applyCourseSearchGroup"
                class="filter-user"
                append-icon="fa-search"
              ></v-text-field>
              <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
                placeholder="Filter course categories" multiple small-chips class="categories" v-model="selectedCategory"
                v-on:change="filterCoursesByCategories($event)" menu-props="content-class: dropdown-below" @click:clear="handleClear">
                <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleSelectAll">
              <v-list-item-action>
                <v-checkbox :input-value="selectAll" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
          </v-select> 
          </div>
            <v-expansion-panels accordion 
              v-model="panel2"
              multiple>
              <v-expansion-panel>
                <v-expansion-panel-header expand-icon="mdi-menu-down" color="grey50" class="assigned-user-heading assigned-user-heading2">Courses</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
                    <v-data-table
                      v-model="selectedCourses"
                      :headers="headers"
                      :options.sync="coursesOption"
                      :server-items-length="serverCoursesLength2"
                      v-show="!loading"
                      :items="courses"
                      show-select
                      item-key="id"
                      :items-per-page="5"
                      class="mb-5 enrol-user-list-tbl"
                      :item-disabled="item => item.is_course_archived"
                      @toggle-select-all="selectAllToggle"
                    >
                      <template v-slot:item.name="{ item }">
                        <div class="course-title-wrapper">
                          <span class="ml-2">{{item.name}}</span>
                          <v-tooltip v-if="item.is_membership" bottom >
                            <template v-slot:activator="{ on }">
                              <div v-on="on" class='isMember-Title'></div>
                            </template>
                            <span>Membership Content</span>
                          </v-tooltip>
                          <v-tooltip v-if="item.is_course_archived" bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              class="ml-1"
                              text
                              color="$improve-grey-900"
                              style="width: auto; cursor: auto;"
                            >
                              <v-icon x-small>fa fa-question</v-icon>
                            </v-btn>
                          </template>
                          <span>This course cannot be assigned because it has been archived.</span
                          >
                        </v-tooltip>
                        </div>
                      </template>
                      <template v-slot:item.published="{ item }">
                        <v-icon v-if="item.published" color="green">fa-check</v-icon>
                        <v-icon v-else color="red">fa-times</v-icon>
                      </template>
                      <template
                        v-slot:item.data-table-select="{
                          item,
                          isSelected,
                          select,
                        }"
                      >
                        <v-simple-checkbox
                          :value="isSelected"
                          :readonly="item.is_course_archived"
                          :disabled="item.is_course_archived"
                          @input="select($event)"
                          :ripple=false
                        ></v-simple-checkbox>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>
    <v-footer absolute height="68">
      <v-flex px-4 py-4 text-right>
        <div v-if="e1 == 1">
          <v-btn color="grey300" class="mr-4 cancel-button" @click="closePanel"
            >Cancel</v-btn
          >
          <v-btn color="primary" class="add-course-button" @click="e1 = 2"
            >Next</v-btn
          >
        </div>
        <div v-if="e1 == 2">
          <v-btn
            v-if="!loading"
            color="grey300"
            class="mr-4 cancel-button"
            @click="e1 = 1"
            >Back</v-btn
          >
          <v-btn v-if="loading" color="primary" loading></v-btn>
          <v-btn
            v-else
            color="primary"
            class="ml-2 add-course-button"
            @click="processCources"
            >Save Courses</v-btn
          >
        </div>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import courseAPI from "@/api/course.js";
import TableThumb from "@/components/admin/course/TableThumb";
import userAPI from "@/api/user.js";
import { EventBus } from "@/event-bus.js";
export default {
  name: "ChannelModules",
  components: {
    TableThumb,
  },
  props: {
    params: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      e1: 1,
      userSearch: "",
      userHeaders: [
        { text: "First Name", value: "first_name" },
        { text: "Surname", value: "last_name" },
        { text: "Email", value: "email" },
      ],
      headers: [
        { text: "Course Name", value: "name", sortable: true},
        {
            text: "Published",
            value: "published",
            sortable: false,
            align: "center",
            class:"published-th-text",
        },
        // { text: "Action", value: "id", sortable: false, align: "left" }
      ],
      userOptions: {},
      coursesOption: {},
      loading: false,
      staffUsers: [],
      userSearchParams: "",
      userPagination: '',
      panel: [0,1],
      panel2: [0,1],
      selectedStaffUser: [],
      coursePagination: '',
      courses: [],
      selectedCourses: [],
      courseSearch: '',
      courseSearchParam: "",
      successMessage: "Courses Successfully enrolled",
      errorMessage:
        "Oops, something went wrong! Please check information is correct.",
      categories: [],
      selectedCategory: [],
    };
  },
  watch: {
    userOptions: {
      handler() {
        this.getStaffUsers();
      },
      deep: true
    },
    coursesOption: {
      handler() {
        this.getCourses();
      },
      deep: true
    }
  },
  computed: {
    serverUser2ItemsLength: function () {
      return this.userPagination.total;
    },
    serverCoursesLength2: function () {
      return this.coursePagination.total;
    },
    courseparams: function() {
      return this.$gf.getQueryString(this.coursesOption, this.serverCoursesLength2);
    },
    userparams: function() {
      return this.$gf.getQueryString(this.userOptions, this.serverCoursesLength2);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
  },
  mounted() {
    this.getAllCourseCategories();
  },
  methods: {
    applyStaffUserSearch() {
      this.userOptions.page = 1;
      this.userSearchParams =
        "&search=first_name:" +
        this.userSearch +
        ";last_name:" +
        this.userSearch;
      this.getStaffUsers();
    },
    applyCourseSearchGroup() {
      this.coursesOption.page = 1;
      this.courseSearchParam = '';
      if (this.courseSearch != null) {
        this.courseSearchParam +=
          "&search=name:" +
          this.courseSearch;
      } 
      if (this.selectedCategory.length) {
        this.courseSearchParam += '&categories=' + this.selectedCategory.toString();
      }
      this.getCourses();
    },
    getStaffUsers() {
      this.loading = true;
      // alert(this.userSearchParams);
      if(this.userSearchParams) {
        this.userparams = this.userparams + this.userSearchParams;
      }
      // alert(this.params);
      userAPI.getManagerTeams(this.userparams + this.userSearchParams).then(response => {
        this.loading = false;
        this.staffUsers = response.data.data;
        this.userPagination = response.data.meta.pagination;
      });
    },
    closePanel() {
      this.$emit("closePanel", {});
    },
    processSelectedStaffUser() {
      let users = [];
      this.selectedStaffUser.forEach(function(x) {
          users.push(x.id);
      });
      return users;
    },
    processSelectedStaffCources() {
      let course = [];
      this.selectedCourses.forEach(function(x) {
          course.push(x.id);
      });
      return course;
    },
    getCourses() {
      this.loading = true;
      courseAPI
      .getCoursesData(this.courseparams + "&include=thumbnail,test", this.courseSearchParam)
      .then(resp => {
          this.courses = resp.data.data;
          this.coursePagination = resp.data.meta.pagination;
          this.loading = false;
      });
    },
    processCources() {
      this.loading = true;
      courseAPI
      .enrolStaffCourse(this.id, {
          assign_courses: this.processSelectedStaffCources(),
          assign_users: this.processSelectedStaffUser()
      })
      .then(() => {
          this.closePanel();
          this.$snotify.success(this.successMessage);
          this.loading = false;
          EventBus.$emit("TEAM_COURSES_UPDATED");
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      })
      .catch(() => {
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
    getAllCourseCategories() {
        courseAPI.getAllCourseCategories().then(response => {
            this.categories = response.data.data;
        });
        },
    filterCoursesByCategories(){
      this.applyCourseSearchGroup();      
    },
    handleClear(){
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory =  this.categories.map((cat) => cat.id);
      }

      this.applyCourseSearchGroup()
    },
    selectAllToggle({ value, items }) {
      if (value) {
        // Only select non-archived items
        const nonArchivedItems = items.filter(item => !item.is_course_archived);

        // Replace the selected2 with only non-archived ones
        this.selectedCourses = [...this.selectedCourses, ...nonArchivedItems.filter(
          newItem => !this.selectedCourses.some(sel => sel.id === newItem.id)
        )];
      } else {
        // Deselect only the visible, non-archived items
        const idsToRemove = items
          .filter(item => !item.is_course_archived)
          .map(item => item.id);

        this.selectedCourses = this.selectedCourses.filter(
          selected => !idsToRemove.includes(selected.id)
        );
      }
    },
  },
};
</script>
<style media="screen">
#slideout-container {
  height: calc(100vh - 65px - 100px);
}
.max-height-list {
  height: calc(100vh - 65px - 100px - 48px);
}
.no-transition .stepper__content {
  transition: none;
}
</style>
<style scoped>
.course-title-wrapper {
    display: flex;
    justify-content: left !important;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 1em;
}

.isMember-Title::after {
    content: "";
    width: 15px;
    height: 14px;
    margin: 4px 1px 0px 0px;
    background-image: url(/static/safeguarding-stars.png);
    background-size: contain;
    background-repeat: no-repeat;
    display: block;
}

.isMember-Title {
    background-color: #83c902;
    height: 20px;
    width: 20px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
}
</style>